import { InvitationErrorCode } from "@/api/types"

interface ErrorMessageConfig {
  title: string
  message: string
  actionText: string
}

const ERROR_MESSAGES: Record<InvitationErrorCode, ErrorMessageConfig> = {
  [InvitationErrorCode.SIGNEE_NOT_READY]: {
    title: "Aún no es tu turno para firmar",
    message:
      "Otros firmantes deben completar su proceso antes de que puedas firmar. Por favor espera a que sea tu turno.",
    actionText: "Esperando el turno para firmar",
  },
  [InvitationErrorCode.INVALID_TOKEN]: {
    title: "Invitación inválida o expirada",
    message:
      "El enlace de invitación ha expirado o no es válido. Por favor solicita un nuevo enlace de invitación.",
    actionText: "El enlace ya no es válido",
  },
  [InvitationErrorCode.INVITATION_PENDING]: {
    title: "Invitación pendiente",
    message:
      "La invitación aún está siendo procesada. Por favor intenta nuevamente en unos minutos.",
    actionText: "La invitación está en proceso",
  },
  [InvitationErrorCode.DOCUMENT_NOT_READY]: {
    title: "Documento en preparación",
    message:
      "El documento está siendo preparado para la firma. Por favor intenta nuevamente en unos minutos.",
    actionText: "El documento se está preparando",
  },
  [InvitationErrorCode.SIGNEE_PENDING]: {
    title: "Procesamiento pendiente",
    message:
      "Tu proceso de verificación aún está siendo procesado. Por favor espera a que se complete.",
    actionText: "El firmante está pendiente de procesamiento",
  },
  [InvitationErrorCode.SIGNEE_FAILED]: {
    title: "Error en el procesamiento",
    message:
      "Ha ocurrido un error durante el procesamiento de tus datos. Por favor contacta soporte.",
    actionText: "El procesamiento del firmante ha fallado",
  },
  [InvitationErrorCode.SIGNEE_ALREADY_SIGNED]: {
    title: "Documento ya firmado",
    message:
      "Ya has firmado este documento anteriormente. No es necesario firmarlo nuevamente.",
    actionText: "Ya firmaste este documento",
  },
  [InvitationErrorCode.SIGNEE_REJECTED]: {
    title: "Documento rechazado",
    message:
      "Has rechazado previamente este documento. Si necesitas firmarlo, contacta a soporte.",
    actionText: "Documento rechazado por el firmante",
  },
}

const DEFAULT_ERROR: ErrorMessageConfig = {
  title: "Error en la invitación",
  message:
    "No se pudo procesar la invitación. Por favor contacta al soporte para obtener ayuda.",
  actionText: "Ha ocurrido un error inesperado",
}

export function getErrorMessage(
  errorCode?: InvitationErrorCode | null,
  fallbackMessage?: string | null,
): ErrorMessageConfig {
  if (errorCode && errorCode in ERROR_MESSAGES) {
    return ERROR_MESSAGES[errorCode]
  }

  // If we have a fallback message, use it with default title
  if (fallbackMessage) {
    return {
      ...DEFAULT_ERROR,
      message: fallbackMessage,
    }
  }

  return DEFAULT_ERROR
}
